import breakpointsFunc from '../breakpointsFunc';
const MuiStepLabel = {
  styleOverrides: {
    root: {
      // '& .MuiStepLabel-label': {
      //   whiteSpace: 'nowrap',
      // },
      '& .MuiStepLabel-iconContainer.MuiStepLabel-alternativeLabel': {
        padding: '0 10px',
        [breakpointsFunc.breakpoints.down('lg')]: {
          padding: '0 5px'
        }
      }
    }
  }
};
export default MuiStepLabel;